module.exports = __webpack_public_path__ + "media/logos/law360-logo-white-2be1272f.png";